// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSgsButton_root__C4o53","text":"PlasmicSgsButton_text__XovlM"};